import store from '../store/index'
export const hasMenu = function (value) {
    let menus = null
    try {
        menus = store.state.user.menus
    } catch (error) {
        menus = null
    }
    if (value && menus) {
        const p = menus.filter(i => i.name === value)
        return p.length > 0
    } else {
        return false
    }
}

export const getRGBA = function (str, opacity) {
  // 16进制颜色值的正则
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  // 把颜色值变成小写
  let color = str.toLowerCase()
  if (reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      let colorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1))
      }
      color = colorNew
    }
    // 处理六位的颜色值，转为RGB
    let colorChange = []
    for (let j = 1; j < 7; j += 2) {
      colorChange.push(parseInt('0x' + color.slice(j, j + 2)))
    }
    return opacity ? 'rgba(' + colorChange.join(',') + ', ' + opacity + ')' : 'rgb(' + colorChange.join(',') + ')'
  } else {
    return color
  }
}

/**
 * 页面初始化时如果使用router.params传递初始化参数，使用此方法缓存参数至localStorage
 * 缓存上个页面传入的信息，当页面被手动刷新时使用
 * @param {*} _this 当前组件上下文
 */
export const getDefaultParams = function (_this) {
  let params = null
  if (_this.$route.params && Object.keys(_this.$route.params).length > 0) {
    window.localStorage.setItem(_this.$options.name, JSON.stringify(_this.$route.params))
    params = _this.$route.params
  } else {
    params = JSON.parse(window.localStorage.getItem(_this.$options.name))
  }
  return params
}

/**
 * 缓存页面指定数据，使用此方法缓存参数至localStorage
 * 当页面被手动刷新时使用
 * @param {*} _this 当前组件上下文
 */
export const getDefaultData = function (key, data) {
  let params = null
  if (data) {
    window.localStorage.setItem(key, JSON.stringify(data))
    params = data
  } else {
    params = JSON.parse(window.localStorage.getItem(key))
  }
  return params
}



// WEBPACK FOOTER //
// ./src/util/prowers.js